export default class AccountService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getAccount(id) {
    return this.$http.get(`/api/account/${id}`);
  }

  deleteAccount(id) {
    return this.$http.delete(`/api/account/${id}`);
  }

  addAccount(account) {
    return this.$http.post('/api/account', account);
  }

  updateAccount(account) {
    return this.$http.put(`/api/account/${account.UserId}`, account);
  }

  isUniqueUsername(username, id) {
    return this.$http.get('/api/account/unique_username', {
      params: {
        username,
        id
      }
    });
  }

  changePassword(credentials) {
    return this.$http.post('/api/account/password_reset', credentials);
  }

  forcePasswordChange(credentials) {
    return this.$http.post('/api/account/password_override', credentials);
  }

  setLockoutStatus(userId, isLocked) {
    return this.$http.put(`/api/account/${userId}/lockout`, {
      userId,
      isLocked
    });
  }

  updateDiscontinuedPreference(userId, showDiscontinuedProducts) {
    return this.$http.put(`/api/account/${userId}/set_search_perference`, {}, {
      params: {
        Is_Show_Discontiuned: showDiscontinuedProducts
      }
    });
  }
}



// WEBPACK FOOTER //
// ./services/account.service.js